import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@reenstudio/environments/environment';
import { ForecastChartApiResponse } from '../../models/charts/forecast-model';

@Injectable({
  providedIn: 'root',
})
export class ForecastChartApiService {
  params: any = {};
  apiUrl = environment.api;
  apiHeaders = environment.apiHeaders;

  constructor(private http: HttpClient) {}

  getForecast(
    start: Date,
    end: Date,
    cer?: number,
    site?: number
  ): Observable<any> {
    this.params.start = this.formatDateTime(start);
    this.params.end = this.formatDateTime(end);

    if (!cer) {
      delete this.params.cer_id;
    } else if (cer) {
      this.params.cer_id = cer;
    }

    if (!site) {
      delete this.params.site_id;
    } else if (site) {
      this.params.site_id = site;
    }

    const apiForecast = `${this.apiUrl}/forecast/period`;

    return this.http.get<ForecastChartApiResponse[]>(apiForecast, {
      headers: this.apiHeaders,
      params: this.params,
    });
  }

  formatDateTime(dateTime: Date): string {
    return dateTime.toISOString().toString().split('T')[0];
  }
}
